import React, {useState, useEffect} from 'react'
import {events20} from 'network/ApiAxiosTickets'
import EventReportSalesCard from "./EventReportSalesCard"
import {Container,Row,Col } from "reactstrap";
import Header from 'components/Headers/Header';


function EventSales() {
    const [events, setEvents] = useState([]);
    useEffect(() => {
        getEvents()
    }, []);

    const getEvents = async()=>{
        const res = await events20()
        setEvents(res.data)
        console.log('all events', res.data)
    }

    const role = JSON.parse(localStorage.getItem('user')).role

  return (
    <>
        {role == 'admin' && <Header/>}
        <Container fluid>
            <Row>
                <h2>Next 20 Events Sales</h2>
            </Row>
          <Row className="mt-4">
            {console.log('top level event log---',events)}
              {events ? events.map((event) =>{return (<EventReportSalesCard key={event._id} prodID={event._id} event={event} />)}) : null}
          </Row>

        </Container>
      </>
  )
}

export default EventSales